import { inject, Injectable } from '@angular/core';
import { map, Observable, of, switchMap } from 'rxjs';

import { CreateWorkflowRequest } from '@blaze-shared/api-contracts-domain';
import { SchemaService } from '@blaze-shared/schema-data-access';

import { WorkflowCrudService } from '../../services/workflow-crud.service';
import { WorkflowContext } from '../models/ai.model';
import { collectWorkflowDatasetIds } from '../page/utils';

@Injectable({ providedIn: 'root' })
export class ComponentSourceWorkflowService {
  private readonly workflowCrudService = inject(WorkflowCrudService);
  private readonly schemaService = inject(SchemaService);

  ensureCreated(
    entry: WorkflowContext,
    projectId: string,
    pageId: string,
  ): Observable<WorkflowContext> {
    const { workflow, inputVariables } = entry;

    const workflow$ = workflow.id
      ? of(workflow)
      : this.workflowCrudService.createWorkflow({
          ...(workflow as unknown as CreateWorkflowRequest),
          projectId,
          pageId,
        });

    return this.ensureDatasetSchemas(collectWorkflowDatasetIds(workflow)).pipe(
      switchMap(() => workflow$),
      map((created) => ({ workflow: created, inputVariables })),
    );
  }

  private ensureDatasetSchemas(datasetIds: string[]): Observable<unknown> {
    if (!datasetIds.length) {
      return of(undefined);
    }
    return this.schemaService.obtainDatasetsSchemas(datasetIds);
  }
}
